var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennisBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.933 40.933",
    style: {
      enableBackground: "new 0 0 40.933 40.933"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M18.546,0.079C13.967,0.506,9.497,2.477,5.984,5.988c-3.513,3.51-5.482,7.98-5.908,12.565 c5.028,0.583,10.374,3.153,14.763,7.542c4.391,4.39,6.964,9.74,7.542,14.764c4.592-0.426,9.051-2.396,12.567-5.905 c3.512-3.509,5.479-7.981,5.903-12.565c-5.016-0.582-10.371-3.152-14.76-7.542C21.705,10.458,19.132,5.107,18.546,0.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M40.933,19.85c-0.149-5.035-2.141-10.023-5.979-13.866C31.114,2.141,26.12,0.156,21.085,0 c0.566,4.397,2.901,9.122,6.815,13.037C31.814,16.952,36.533,19.283,40.933,19.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M0.001,21.09c0.148,5.033,2.141,10.022,5.983,13.863c3.839,3.839,8.827,5.834,13.861,5.98 c-0.566-4.391-2.898-9.113-6.814-13.028C9.119,23.992,4.395,21.66,0.001,21.09z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisBall);
export default __webpack_public_path__ + "static/media/tennisBall.da3de5816b436cd214bc1076650102c9.svg";
export { ForwardRef as ReactComponent };